export default "<p>\n  edit-admins works!\n</p>\n"